import React from 'react';

const ConditionSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M18.7744 19H1.22563C1.10091 19 1 18.8991 1 18.7744V1.22563C1 1.10091 1.10091 1 1.22563 1H18.7744C18.8991 1 19 1.10091 19 1.22563V18.7744C19 18.8991 18.8991 19 18.7744 19ZM1.45125 18.5487H18.5487V1.45125H1.45125V18.5487ZM5.08322 13.0685H6.9484V9.27799H5.08322V8.58607H7.75063V13.0685H9.49547V13.7604H5.08322V13.0685ZM7.34951 7.4429C7.11511 7.4429 6.95153 7.39464 6.85815 7.29749C6.76476 7.20097 6.71776 7.07876 6.71776 6.93148V6.77103C6.71776 6.62375 6.76414 6.50216 6.85815 6.40501C6.95216 6.30787 7.11574 6.25961 7.34951 6.25961C7.58329 6.25961 7.74687 6.30787 7.84088 6.40501C7.93426 6.50216 7.98127 6.62375 7.98127 6.77103V6.93148C7.98127 7.07876 7.93426 7.20097 7.84088 7.29749C7.74749 7.39464 7.58391 7.4429 7.34951 7.4429ZM10.8229 13.0685H12.5678V9.27799H10.7226V8.58607H12.5678V7.52312C12.5678 7.17591 12.6593 6.89136 12.8435 6.67075C13.0278 6.45014 13.3167 6.33983 13.7109 6.33983H15.4458V7.03175H13.37V8.58607H15.4458V9.27799H13.37V13.0685H15.2151V13.7604H10.8229V13.0685Z"
        fill={color}
        stroke="black"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ConditionSVG;
